<template>
  <div class="" style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class='col-md-8 d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1 v-if="serialDialog.data">Manage Dispatches for Order #{{$route.params.oid}}</h1>
          <confirmedActionButton
              class="mx-2"
              color="info"
              buttonText=""
              fab
              xsmall
              v-if="order?.status===1 && order?.deliveryInfo.deliveryType==='delivery'"
              :disabled="serialDialog.data && order?.deliveryInfo.status==2"
              :loading="createDispatchLoading"
              @cb="createNewDispatch($route.params.oid)"
              fabIcon="mdi-plus"
          />
          <v-btn class="mr-2" v-if="order && isAllowed('order', 'r')" color="info" small @click="$router.push(`/orders/view/${$route.params.oid}`)">Go To Order #{{$route.params.oid}}</v-btn>
          <v-btn :loading="oneClickDispatchLoader" color="warning" small @click="oneClickDispatch" v-if="order && !serialDialog.data?.Order?.deliveryInfo.status && isAllowed('dispatch', 'oneClickDispatch')">One-click Dispatch</v-btn>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="serialDialog.isSyncing"
              class="ml-2"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-if="serialDialog.data">
        <v-col>
          <span>
            <b>Current order delivery progress:</b> <v-chip small :color="utils.getDeliveryStatusColor(serialDialog.data.Order.deliveryInfo.status)">{{utils.parseDeliveryStatus(serialDialog.data.Order.deliveryInfo.status)}}</v-chip>
          </span>
        </v-col>
      </v-row>
      <v-row v-if="order?.status!==1">
        <v-col>
          <h3>This order is not sealed.</h3>
        </v-col>
      </v-row>
      <v-row v-else-if="order?.deliveryInfo.deliveryType!=='delivery'">
        <v-col>
          <h3>This is not a delivery order.</h3>
        </v-col>
      </v-row>
      <v-row v-else-if="allOrderDispatches.length===0">
        <v-col>
          <h3>This order currently has no dispatches.</h3>
        </v-col>
      </v-row>
      <v-row v-if="allOrderDispatches">
        <v-col cols="2">
          <span v-if="allOrderDispatches.length > 0" class="d-flex flex-column" style="max-height: 80vh; overflow-y: scroll">
            <v-card class="mb-2" outlined v-for="(dispatch,index) in allOrderDispatches" :key="index" @click="clickDispatch(dispatch.id)">
              <v-card-text>
                <v-chip small :color="utils.getDispatchStatusColor(dispatch.status)">{{(![0, -1, 5, -2].includes(dispatch.status) && dispatch.scheduledOutAt && !(dispatch.scheduledOutAt >= today))?'Delayed - ':''}}{{ utils.parseDispatchStatus(dispatch.status) }}</v-chip>
                <h4>DISPATCH #{{$route.params.oid}}-{{ dispatch.id }}</h4>
                <span class="d-flex flex-column">
                  <span>Scheduled For: {{ dispatch.scheduledOutAt?utils.parseDate(dispatch.scheduledOutAt, 2):'No Date Set' }}</span>
                  <span>Driver: {{ dispatch.driver || 'No Driver Set' }}</span>
                </span>
              </v-card-text>
            </v-card>
          </span>
        </v-col>
        <v-col>
          <v-card outlined v-if="serialDialog.data">
            <v-card-text>
            <span class="d-flex flex-row align-center justify-space-between mb-4">
              <span class="d-flex flex-row align-center">
                <h2>DISPATCH #{{serialDialog.data.orderId}}-{{ serialDialog.data.id }}</h2>
                <span class="ml-2">
                  <dynamicButtonContainer v-if="serialDialog.data.status!==-1" :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_DISPATCH_DIALOG')}`" :data="{status: serialDialog.data.status, id1: serialDialog.data.orderId, id2: serialDialog.data.id}"/>
                </span>
              </span>
              <span class="d-flex flex-row">
                <v-btn class="mx-2" :disabled="((serialDialog.data.status===-1 || serialDialog.data.status===5)) || loader" color="success" @click="saveDispatch(serialDialog.data.dbID)">Save Changes</v-btn>
                <v-select style="max-width: 200px;" dense :disabled="(changeDispatchStatusRules) || loader" hide-details label="Status" item-text="text" item-value="value" outlined v-model="tempStatus" :items="dispatchStatuses.filter(x => (dispatchStatuses.find(y => y.value===serialDialog.data.status)?.allowedNext||[]).includes(x.value))"/>
              </span>
            </span>
              <v-row>
                <v-col cols="8">
                  <v-form :disabled="(serialDialog.data.status===-1 || serialDialog.data.status===5) || loader">
                    <v-card outlined>
                      <v-card-text outlined class="d-flex flex-row">
                    <span class="mr-4 d-flex flex-column align-start justify-start">
                      <v-date-picker :disabled="(serialDialog.data.status===-1 || serialDialog.data.status===5) || loader" dense label="Scheduled For" v-model="serialDialog.data.scheduledOutAt"/>
                    </span>
                        <v-row>
                          <v-col>
                            <h3 class="mb-3">Driver Details</h3>
                            <v-text-field label="Driver" outlined dense hide-details class="mb-1" v-model="serialDialog.data.driver"/>
                            <v-textarea class="mb-1" hide-details outlined dense label="Notes" v-model="serialDialog.data.notes"/>
                          </v-col>
                          <v-col>
                            <h3 class="mb-3 d-flex flex-row align-center">
                              <span>Delivery Address</span>
                              <v-btn :disabled="(serialDialog.data.status===-1 || serialDialog.data.status===5) || loader" class="ml-2" x-small color=info fab @click="importAddressFromOrder"><v-icon>mdi-application-import</v-icon></v-btn>
                            </h3>
                            <v-text-field label="Address Line 1" outlined dense hide-details class="mb-1" v-model="serialDialog.data.address.line1"/>
                            <v-text-field label="Address Line 2" outlined dense hide-details class="mb-1" v-model="serialDialog.data.address.line2"/>
                            <v-text-field label="City" outlined dense hide-details class="mb-1" v-model="serialDialog.data.address.city"/>
                            <v-text-field label="Country" outlined dense hide-details class="mb-1" v-model="serialDialog.data.address.country"/>
                            <v-text-field label="Phone" outlined dense hide-details class="mb-1" v-model="serialDialog.data.address.phone"/>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-form>
                  <v-card class="mt-2" outlined>
                    <v-card-text class="d-flex flex-column">
                    <span class="d-flex flex-row align-center">
                      <h2 class="mr-2">Items in this Dispatch</h2>
                      <v-btn v-if="!((serialDialog.data.status!==0) || loader)" :disabled="(allOrderDispatches.length!==1) || loader" color="info" small @click="fillQTYBalance(null, null)" :loading="fillLoading">Fill in Balance For All Items</v-btn>
                      <v-progress-circular
                          indeterminate
                          color="green"
                          v-if="serialDialog.isSyncing"
                          class="ml-2"
                      ></v-progress-circular>
                    </span>
                      <div class="mb-4 d-flex flex-column justify-space-between">
                        <template v-for="(item,index) in serialDialog.data.DispatchLineItems" >
                          <span v-if="!item.metadata.compositeProductData" :key="index" class="d-flex flex-column flex-grow-1">
                            <span class="d-flex flex-row align-center justify-space-between">
                              <span class="d-flex flex-row align-center">
                                <div class="mr-2" v-if="item.metadata?.quantities?.length>0">
                                  <span class="d-flex flex-row align-center" v-for="(loc, j) in item.metadata.quantities" :key="'warehousing'+j">
                                    <v-text-field hide-details :disabled="(serialDialog.data.status!==0) || loader" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" :min="utils.pff(item.metadata?.quantityStepAmount||1)" dense v-model="loc.deliveryQuantity" @change="updateLineItem(item)" :label="lookupBranch(loc.locationId)||'Deleted Location'" :max="item.max" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 100px;" outlined/>
                                    <span class="ml-2">In Stock: {{getPLJQTY(item.productId, loc.locationId)}}</span>
                                    <v-btn v-if="!((serialDialog.data.status!==0) || loader)" color="info" class="ml-1" x-small @click="fillQTYBalance(item, loc)">Fill</v-btn>
                                    <span class="mx-2">
                                      <v-badge v-if="!computeLineItem(item)?.Product.metadata?.allowFractional && computeLineItem(item)?.Product.metadata?.requireSerials && (utils.pff(loc.deliveryQuantity)-item.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">
                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                                      </v-badge>
                                      <v-badge v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional && (utils.pff(loc.deliveryQuantity)-item.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(loc.deliveryQuantity)<item.serials?.filter(x => x.locationId===loc.locationId)?.length?'error':'success'" :content="`${(utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">
                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                                      </v-badge>
                                      <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>
                                      <span v-else-if="computeLineItem(item)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>
                                    </span>
                                    <span class="ml-2">Order: {{loc.quantity||0}}</span>
                                  </span>
                                  <span :style="`${utils.pff(item.quantity) > utils.pff(computeLineItem(item)?.quantity||0)?'color: red;':''}`">Total: {{utils.pff(item.quantity)}}</span>
                                </div>
                                <div class="mr-2" v-else>
                                  <v-text-field :disabled="(serialDialog.data.status!==0) || loader" label="Quantity" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" hide-details :min="utils.pff(item.metadata?.quantityStepAmount||1)" dense v-model="item.quantity" @change="updateLineItem(item)" :max="item.max" style="width: 100px;" outlined/>
                                </div>
                                <span class="ml-3 d-flex flex-column">
                                  <h4>{{ computeProductName(item.productId) }}
                                    <router-link v-if="isAllowed('product', 'u')" :to="'/products/view/'+item.productId">[PL-{{item.productId}}]</router-link>
                                    <span v-else>[PL-{{item.productId}}]</span>
                                    <br>
                                    <span>Total from Sale Order: {{computeLineItem(item)?.quantity||0}}</span>
                                  </h4>
                                </span>
                                <span class="ml-5">
                                  <v-badge v-if="!computeLineItem(item)?.Product.metadata?.allowFractional && computeLineItem(item)?.Product.metadata?.requireSerials && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">
                                    <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                                  </v-badge>
                                  <v-badge v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(item.quantity)<item.serials?.length?'error':'success'" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">
                                    <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                                  </v-badge>
                                  <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>
                                  <span v-else-if="computeLineItem(item)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>
                                </span>
                              </span>
                              <span class="d-flex flex-row align-center justify-space-between">
                                <span class="d-flex flex-column">
                                  <b>Total Balance: {{item.balance||0}}</b>
                                  <span>Total Scheduled: {{item.scheduledQuantity||0}}</span>
                                  <span>Total Out For Delivery: {{item.outForDeliveryQuantity||0}}</span>
                                  <span>Total Delivered: {{item.deliveredQuantity||0}}</span>
                                </span>
                              </span>
                              <!-- <v-btn class="ml-2" color="success" x-small fab @click="addProductToDispatch"><v-icon>mdi-plus</v-icon> </v-btn> -->
                            </span>
                            <v-divider v-if="index < serialDialog.data.DispatchLineItems.length-1"></v-divider>
                          </span>
                          <span v-else :key="index" class="d-flex flex-column flex-grow-1">
                            <span class="d-flex flex-row align-center justify-space-between">
                              <span class="d-flex flex-row align-center">
                                <div class="mr-2" v-if="item.metadata?.quantities?.length>0">
                                  <span class="d-flex flex-row align-center" v-for="(loc, j) in item.metadata.quantities" :key="'warehousing'+j">
                                    <v-text-field :disabled="((serialDialog.data.status!==0) || loader) || !item.metadata.useCompositeQuantities" hide-details type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" :min="utils.pff(item.metadata?.quantityStepAmount||1)" dense v-model="loc.deliveryQuantity" @change="updateLineItem(item)" :label="lookupBranch(loc.locationId)||'Deleted Location'" :max="item.max" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 100px;" outlined/>
                                    <span class="ml-2">In Stock: {{getPLJQTY(item.productId, loc.locationId)}}</span>
                                    <v-btn v-if="(!((serialDialog.data.status!==0) || loader)) && item.metadata.useCompositeQuantities" color="info" class="ml-1" x-small @click="fillQTYBalance(item, loc)">Fill</v-btn>
<!--                                    <span class="mx-2">-->
<!--                                      <v-badge v-if="!computeLineItem(item)?.Product.metadata?.allowFractional && computeLineItem(item)?.Product.metadata?.requireSerials && (utils.pff(loc.deliveryQuantity)-item.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">-->
<!--                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                      </v-badge>-->
<!--                                      <v-badge v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional && (utils.pff(loc.deliveryQuantity)-item.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(loc.deliveryQuantity)<item.serials?.filter(x => x.locationId===loc.locationId)?.length?'error':'success'" :content="`${(utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(loc.deliveryQuantity)-(item.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">-->
<!--                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                      </v-badge>-->
<!--                                      <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                      <span v-else-if="computeLineItem(item)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>-->
<!--                                    </span>-->
                                    <span class="ml-2">Order: {{loc.quantity||0}}</span>
                                  </span>
                                  <span :style="`${utils.pff(item.quantity) > utils.pff(computeLineItem(item)?.quantity||0)?'color: red;':''}`">Total: {{utils.pff(item.quantity)}}</span>
                                </div>
                                <div class="mr-2" v-else>
                                  <v-text-field :disabled="((serialDialog.data.status!==0) || loader) || !item.metadata.useCompositeQuantities" label="Quantity" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" hide-details :min="utils.pff(item.metadata?.quantityStepAmount||1)" dense v-model="item.quantity" @change="updateLineItem(item)" :max="item.max" style="width: 100px;" outlined/>
                                </div>
                                <span class="ml-3 d-flex flex-column">
                                  <h4>{{ computeProductName(item.productId) }}
                                    <router-link v-if="isAllowed('product', 'u')" :to="'/products/view/'+item.productId">[PL-{{item.productId}}]</router-link>
                                    <span v-else>[PL-{{item.productId}}]</span>
                                    <br>
                                    <span>Total from Sale Order: {{computeLineItem(item)?.quantity||0}}</span>
                                  </h4>
                                </span>
<!--                                <span class="ml-5">-->
<!--                                  <v-badge v-if="!computeLineItem(item)?.Product.metadata?.allowFractional && computeLineItem(item)?.Product.metadata?.requireSerials && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">-->
<!--                                    <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                  </v-badge>-->
<!--                                  <v-badge v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(item.quantity)<item.serials?.length?'error':'success'" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">-->
<!--                                    <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                  </v-badge>-->
<!--                                  <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(item)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>-->
<!--                                  <span v-else-if="computeLineItem(item)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>-->
<!--                                </span>-->
                              </span>
                              <span class="d-flex flex-row align-center justify-space-between">
                                <span class="d-flex flex-column">
                                  <b>Total Balance: {{item.balance||0}}</b>
                                  <span>Total Scheduled: {{item.scheduledQuantity||0}}</span>
                                  <span>Total Out For Delivery: {{item.outForDeliveryQuantity||0}}</span>
                                  <span>Total Delivered: {{item.deliveredQuantity||0}}</span>
                                </span>
                              </span>
                            </span>
                            <span class="d-flex flex-row">
                              <span class="d-flex flex-column align-center">
                                <v-btn :disabled="serialDialog.data.status!==0 || loader" class="mt-2" tile elevation="2" color="warning" small @click="openConfirmCompositeQuantityTypeDialog(item)" icon><v-icon v-if="item.metadata.useCompositeQuantities">mdi-arrow-right-bottom-bold</v-icon><v-icon v-else>mdi-arrow-up-left-bold</v-icon></v-btn>
                                <b style="writing-mode: sideways-lr" class="px-5 d-flex flex-fill justify-center">
                                  Composing Products
                                </b>
                              </span>
                              <span class="d-flex flex-column flex-fill">
                                <span v-for="(rawMat, j) of item.metadata.compositeProductData" :key="'rawMat'+j" class="d-flex flex-column flex-grow-1">
                                  <span class="d-flex flex-row align-center justify-space-between">
                                    <span class="d-flex flex-row align-center">
                                      <div class="mr-2" v-if="rawMat.metadata.quantities?.length>0">
                                        <span class="d-flex flex-row align-center" v-for="(loc, k) in rawMat.metadata.quantities" :key="'rawMatInner'+k">
                                          <v-text-field :disabled="((serialDialog.data.status!==0) || loader) || item.metadata.useCompositeQuantities" hide-details type="number" :step="utils.pff(rawMat.metadata?.quantityStepAmount||1)" :min="utils.pff(rawMat.metadata?.quantityStepAmount||1)" dense v-model="loc.deliveryQuantity" @change="updateLineItem(rawMat)" :label="lookupBranch(loc.locationId)||'Deleted Location'" :max="rawMat.max" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 100px;" outlined/>
                                          <span class="ml-2">In Stock: {{getPLJQTY(item.productId, loc.locationId)}}</span>
                                          <v-btn v-if="!(((serialDialog.data.status!==0) || loader)) && !item.metadata.useCompositeQuantities" color="info" class="ml-1" x-small @click="fillQTYBalance(rawMat, loc)">Fill</v-btn>
                                          <!--                                        <span class="mx-2">-->
                                          <!--                                          <v-badge v-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional && computeLineItem(rawMat)?.Product.metadata?.requireSerials && (utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-(rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-(rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">-->
                                          <!--                                            <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(rawMat, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
                                          <!--                                          </v-badge>-->
                                          <!--                                          <v-badge v-else-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional && (utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)<rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length?'error':'success'" :content="`${(utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-(rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length))!==0?utils.pff(rawMat.metadata.quantities[k].deliveryQuantity)-(rawMat.serials?.filter(x => x.locationId===loc.locationId)?.length):''}`">-->
                                          <!--                                            <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(rawMat, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
                                          <!--                                          </v-badge>-->
                                          <!--                                          <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(rawMat, loc)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>-->
                                          <!--                                          <span v-else-if="computeLineItem(rawMat)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>-->
                                          <!--                                        </span>-->
                                          <span class="ml-2">Order: {{loc.quantity}}</span>
                                        </span>
                                        <span :style="`${utils.pff(rawMat.quantity) > utils.pff(rawMat.totalQuantity)?'color: red;':''}`">Total: {{utils.pff(rawMat.quantity)}}</span>
                                      </div>
                                      <div class="mr-2" v-else>
                                        <v-text-field :disabled="((serialDialog.data.status!==0) || loader) || item.metadata.useCompositeQuantities" label="Quantity" type="number" :step="utils.pff(rawMat.metadata?.quantityStepAmount||1)" hide-details :min="utils.pff(rawMat.metadata?.quantityStepAmount||1)" dense v-model="rawMat.quantity" @change="updateLineItem(rawMat)" :max="rawMat.max" style="width: 100px;" outlined/>
                                      </div>
                                      <span class="ml-3 d-flex flex-column">
                                        <h4 class="d-flex flex-column">
                                          <span>{{ rawMat.productName }} <router-link v-if="isAllowed('product', 'u')" :to="'/products/view/'+rawMat.productId">[PL-{{rawMat.productId}}]</router-link><span v-else>[PL-{{rawMat.productId}}]</span></span>
                                          <span v-if="rawMat.sku">{{rawMat.sku}}</span>
                                          <span>Total from Sale Order: {{rawMat.totalQuantity}}</span>
                                          <span>QTY per Unit: {{rawMat.metadata.baseQuantity}}</span>
                                        </h4>
                                      </span>
                                      <!--                                    <span class="ml-5">-->
                                      <!--                                      <v-badge v-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional && computeLineItem(rawMat)?.Product.metadata?.requireSerials && (utils.pff(rawMat.quantity)-rawMat.serials?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(rawMat.quantity)-(rawMat.serials?.length))!==0?utils.pff(rawMat.quantity)-(rawMat.serials?.length):''}`">-->
                                      <!--                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(rawMat)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
                                      <!--                                      </v-badge>-->
                                      <!--                                      <v-badge v-else-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional && (utils.pff(rawMat.quantity)-rawMat.serials?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(rawMat.quantity)<rawMat.serials?.length?'error':'success'" :content="`${(utils.pff(rawMat.quantity)-(rawMat.serials?.length))!==0?utils.pff(rawMat.quantity)-(rawMat.serials?.length):''}`">-->
                                      <!--                                        <v-btn :disabled="loader" class="ml-1 mb-1" @click="openLineItemSerialsDialog(rawMat)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>-->
                                      <!--                                      </v-badge>-->
                                      <!--                                      <v-btn :disabled="loader" color="success" v-else-if="!computeLineItem(rawMat)?.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openLineItemSerialsDialog(rawMat)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>-->
                                      <!--                                      <span v-else-if="computeLineItem(rawMat)?.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>-->
                                      <!--                                    </span>-->
                                    </span>
                                    <span class="d-flex flex-row align-center justify-space-between">
                                      <span class="d-flex flex-column">
                                        <b>Total Balance: {{rawMat.balance||0}}</b>
                                        <span>Total Scheduled: {{rawMat.scheduledQuantity||0}}</span>
                                        <span>Total Out For Delivery: {{rawMat.outForDeliveryQuantity||0}}</span>
                                        <span>Total Delivered: {{rawMat.deliveredQuantity||0}}</span>
                                      </span>
                                    </span>
                                    <!-- <v-btn class="ml-2" color="success" x-small fab @click="addProductToDispatch"><v-icon>mdi-plus</v-icon> </v-btn> -->
                                  </span>
                                  <v-divider v-if="j < item.metadata.compositeProductData.length-1"></v-divider>
                                </span>
                              </span>
                            </span>
                            <v-divider v-if="index < serialDialog.data.DispatchLineItems.length-1"></v-divider>
                          </span>
                        </template>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card outlined>
                    <v-card-text>
                      <div class="ml-4 d-flex flex-column" style="overflow-y: scroll; overflow-x: hidden; max-height: 800px;">
                        <h3 class="mb-3">Timeline</h3>
                        <v-timeline class="ml-n7" id="timeline" dense clipped>
                          <v-slide-x-reverse-transition
                              group
                              hide-on-leave
                          >
                            <v-timeline-item
                                v-for="(item, index) in serialDialog.data.history"
                                :key="index"
                                small
                                fill-dot
                            >
                              <v-alert
                                  :value="true"
                                  class="white--text d-flex flex-column"
                                  color="info"
                                  dense
                                  small
                              >
                                <div style="font-size: 14px;">{{item.description}}</div>
                                <b style="font-size: 12px;">{{ lookupUsername(item.createdBy) }} at {{ utils.formatDate(item.createdAt, 'withTime') }}</b>
                              </v-alert>
                            </v-timeline-item>
                          </v-slide-x-reverse-transition>
                        </v-timeline>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="lineItemSerialsDialog.isOpen" width="1000">
      <v-card>
        <v-card-title v-if="lineItemSerialsDialog.data">
          {{serialNaming.plural}} for {{computeLineItem(lineItemSerialsDialog.data)?.productName}} (ID: {{lineItemSerialsDialog.data.productId}})
        </v-card-title>
        <v-card-text v-if="lineItemSerialsDialog.data && serialDialog.data && lineItemSerialsDialog.filtered">
          <v-row>
            <v-col v-if="getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')!=='true'" cols="4" style="border-right: 1px solid #eee" class="d-flex flex-column">
              <span v-if="serialDialog.data.status===0" class="d-flex flex-column">
                <h3>Add {{serialNaming.singular}}</h3>
                <span class="d-flex flex-row justify-space-between align-center">
                  <v-text-field clearable @keydown.enter="addLineItemSerial" :loading="lineItemSerialsDialog.isLoading" v-model="lineItemSerialsDialog.newSerial" outlined hide-details dense :label="`${serialNaming.singular}`"/>
                  <v-btn :disabled="(lineItemSerialsDialog.data.serials?.length>=utils.pff(lineItemSerialsDialog.data.quantity))||!lineItemSerialsDialog.newSerial" :loading="lineItemSerialsDialog.isLoading" @click="addLineItemSerial" class="ml-2" color="success" fab x-small><v-icon>mdi-plus</v-icon></v-btn>
                </span>
                <span v-if="lineItemSerialsDialog.data.Product?.metadata?.requireSerials" class="red--text">This product requires all {{serialNaming.pluralLower}} to be entered.</span>
                <span v-if="lineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">All {{serialNaming.pluralLower}} must be unique from all other products and itself.</span>
                <span v-if="!lineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">This product does not have {{serialNaming.pluralLower}} required but must still be unique if they're included.</span>
                <hr class="my-3">
              </span>
              <span>
                <h2>{{serialNaming.plural}} From Sale Order / Already Dispatched</h2>
                <span v-if="serialDialog.data.Order.ProductSerials.length>0">
                  <span v-if="serialDialog.data.status===0">You can only add these by typing it in or scanning it.</span>
                  <div class="mt-2" v-if="getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')==='true'">
                    <span v-for="(warehouse, w) of warehouses" :key="w">
                      <h3>{{lookupBranch(warehouse.id)}}</h3>
                      <span v-if="serialDialog.data.Order.ProductSerials.filter(x => (x.locationId===warehouse.id || x.OrderSerialJoin?.metadata?.soldFrom===warehouse.id) && x.productId===lineItemSerialsDialog.data.productId).length>0">
                        <v-card class="mb-2" outlined v-for="(serial, i) of serialDialog.data.Order.ProductSerials.filter(x => (x.locationId===warehouse.id || x.OrderSerialJoin?.metadata?.soldFrom===warehouse.id) && x.productId===lineItemSerialsDialog.data.productId)" :key="i">
                          <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                            <b>{{serial.serial}}</b>
                            <span class="d-flex flex-row">
                              <v-btn v-if="isAllowed('dispatch', 'removeSerialFromOrder') && serialDialog.data.status===0" :disabled="lineItemSerialsDialog.isLoading" @click="openRemoveOrderLineItemSerialDialog(serial)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                            </span>
                          </span>
                        </v-card>
                      </span>
                      <span v-else>
                        <span>No matching {{serialNaming.pluralLower}} entered for this location.</span>
                      </span>
                      <hr class="mb-2">
                    </span>
                  </div>
                  <div class="mt-2" v-else>
                    <v-card class="mb-2" outlined v-for="(serial, i) of lineItemSerialsDialog.data.ProductSerials" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}}</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="isAllowed('dispatch', 'removeSerialFromOrder') && serialDialog.data.status===0" :disabled="lineItemSerialsDialog.isLoading" @click="openRemoveOrderLineItemSerialDialog(serial)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </div>
                </span>
                <span v-else>
                  No {{serialNaming.pluralLower}} in this sale order.
                </span>
              </span>
            </v-col>
            <v-col>
              <h3>{{serialNaming.plural}} ({{lineItemSerialsDialog.data.serials?.length||0}}/{{utils.pff(lineItemSerialsDialog.data.quantity)}})</h3>
              <v-text-field :disabled="lineItemSerialsDialog.data.serials.length===0" :hint="lineItemSerialsDialog.data.serials.length===0?'No items in list.':''" :persistent-hint="lineItemSerialsDialog.data.serials.length===0" dense outlined label="Search List" v-model="lineItemSerialsDialog.search" clearable @input="filterLineItemSerials"/>
              <span v-if="getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')==='true'" class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
                <span v-for="(warehouse, w) of warehouses" :key="w">
                  <h3>{{lookupBranch(warehouse.id)}}</h3>
                  <span v-if="lineItemSerialsDialog.filtered.filter(x => x.locationId===warehouse.id || computeProductSerial(x.id)?.OrderSerialJoin?.metadata?.soldFrom===warehouse.id).length>0">
                    <v-card class="mb-2" outlined v-for="(serial, i) of lineItemSerialsDialog.filtered.filter(x => x.locationId===warehouse.id || computeProductSerial(x.id)?.OrderSerialJoin?.metadata?.soldFrom===warehouse.id)" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}} (ID: {{serial.id}})</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="serialDialog.data.status===0" :disabled="lineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, lineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </span>
                  <span v-else>
                    <span>No matching serials entered for this location.</span>
                  </span>
                  <hr class="mb-2">
                </span>
              </span>
              <span v-else class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
              <v-card class="mb-2" outlined v-for="(serial, i) of lineItemSerialsDialog.filtered" :key="i">
                <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                  <b>{{serial.serial}}</b>
                  <span class="d-flex flex-row">
                    <v-btn v-if="serialDialog.data.status===0" :disabled="lineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, lineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                    <!-- <v-btn v-if="serialDialog.data.status && serialDialog.data.status>=1" class="ml-2" @click="$router.push({path: '/products/serial/'+serial.serial})" color="success" fab x-small><v-icon>mdi-history</v-icon></v-btn> -->
                  </span>
                  <!-- <v-btn v-if="!serialDialog.data.status || serialDialog.data.status<1" :disabled="lineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, lineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn> -->
                </span>
              </v-card>
            </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeLineItemSerialsDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeOrderLineItemSerialDialog.isOpen" width="400">
      <v-card>
        <v-card-title>Remove {{serialNaming.singular}} from Sale Order?</v-card-title>
        <v-card-text v-if="removeOrderLineItemSerialDialog.data">
          Are you sure you want to remove {{serialNaming.singular}} - {{removeOrderLineItemSerialDialog.data.serial}}, from the Sale Order?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeRemoveOrderLineItemSerialDialog">Cancel</v-btn>
          <v-btn color="error" @click="removeOrderLineItemSerial">Remove {{serialNaming.singular}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmCompositeQuantityType.isOpen" width="auto">
      <v-card>
        <v-card-title>Are you sure you want to change the quantity editor for this product?</v-card-title>
        <v-card-text>
          Doing so will clear any currently entered quantities on this product.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="closeConfirmCompositeQuantityTypeDialog">Cancel</v-btn>
          <v-btn color="warning" @click="updateCompositeQuantityType">Confirm Change</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="warehouseLineItemSerialsDialog.isOpen" width="1000">
      <v-card>
        <v-card-title v-if="warehouseLineItemSerialsDialog.data">
          {{serialNaming.plural}} for {{computeLineItem(warehouseLineItemSerialsDialog.data)?.productName}} (ID: {{warehouseLineItemSerialsDialog.data.productId}}) from {{lookupBranch(warehouseLineItemSerialsDialog.location)}}
        </v-card-title>
        <v-card-text v-if="warehouseLineItemSerialsDialog.data && serialDialog.data && warehouseLineItemSerialsDialog.filtered">
          <v-row>
            <v-col cols="4" style="border-right: 1px solid #eee" class="d-flex flex-column">
              <span v-if="serialDialog.data.status===0" class="d-flex flex-column">
                <h3>Add {{serialNaming.singular}}</h3>
                <span class="d-flex flex-row justify-space-between align-center">
                  <v-text-field clearable @keydown.enter="addWarehouseLineItemSerial" :loading="warehouseLineItemSerialsDialog.isLoading" v-model="warehouseLineItemSerialsDialog.newSerial" outlined hide-details dense :label="`${serialNaming.singular}`"/>
                  <v-btn :disabled="(warehouseLineItemSerialsDialog.data.serials?.length>=utils.pff(warehouseLineItemSerialsDialog.data.quantity))||!warehouseLineItemSerialsDialog.newSerial" :loading="warehouseLineItemSerialsDialog.isLoading" @click="addWarehouseLineItemSerial" class="ml-2" color="success" fab x-small><v-icon>mdi-plus</v-icon></v-btn>
                </span>
                <span v-if="warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials" class="red--text">This product requires all {{serialNaming.pluralLower}} to be entered.</span>
                <span v-if="warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">All {{serialNaming.pluralLower}} must be unique from all other products and itself.</span>
                <span v-if="!warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">This product does not have {{serialNaming.pluralLower}} required but must still be unique if they're included.</span>
                <hr class="my-3">
              </span>
              <span>
                <h2>{{serialNaming.plural}} From Sale Order / Already Dispatched</h2>
                <span v-if="serialDialog.data.Order.ProductSerials.length>0">
                  <span v-if="serialDialog.data.status===0">You can only add these by typing it in or scanning it.</span>
                  <div class="mt-2" v-if="getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')==='true'">
                    <span>
                      <h3>{{lookupBranch(warehouseLineItemSerialsDialog.location)}}</h3>
                      <span v-if="serialDialog.data.Order.ProductSerials.filter(x => (x.locationId===warehouseLineItemSerialsDialog.location || x.OrderSerialJoin?.metadata?.soldFrom===warehouseLineItemSerialsDialog.location) && x.productId===warehouseLineItemSerialsDialog.data.productId).length>0">
                        <v-card class="mb-2" outlined v-for="(serial, i) of serialDialog.data.Order.ProductSerials.filter(x => (x.locationId===warehouseLineItemSerialsDialog.location || x.OrderSerialJoin?.metadata?.soldFrom===warehouseLineItemSerialsDialog.location) && x.productId===warehouseLineItemSerialsDialog.data.productId)" :key="i">
                          <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                            <b>{{serial.serial}}</b>
                            <span class="d-flex flex-row">
                              <v-btn v-if="isAllowed('dispatch', 'removeSerialFromOrder') && serialDialog.data.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="openRemoveOrderLineItemSerialDialog(serial)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                            </span>
                          </span>
                        </v-card>
                      </span>
                      <span v-else>
                        <span>No matching {{serialNaming.pluralLower}} entered for this location.</span>
                      </span>
                      <hr class="mb-2">
                    </span>
                  </div>
                  <div class="mt-2" v-else>
                    <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.data.ProductSerials" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}}</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="isAllowed('dispatch', 'removeSerialFromOrder') && serialDialog.data.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="openRemoveOrderLineItemSerialDialog(serial)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </div>
                </span>
                <span v-else>
                  No {{serialNaming.pluralLower}} in this sale order.
                </span>
              </span>
            </v-col>
            <v-col>
              <h3>{{serialNaming.plural}} ({{warehouseLineItemSerialsDialog.data.serials?.length||0}}/{{utils.pff(warehouseLineItemSerialsDialog.data.metadata?.quantities?.find(x => x.locationId===warehouseLineItemSerialsDialog.location)?.deliveryQuantity||0)}})</h3>
              <v-text-field :disabled="warehouseLineItemSerialsDialog.data.serials.length===0" :hint="warehouseLineItemSerialsDialog.data.serials.length===0?'No items in list.':''" :persistent-hint="warehouseLineItemSerialsDialog.data.serials.length===0" dense outlined label="Search List" v-model="warehouseLineItemSerialsDialog.search" clearable @input="filterWarehouseLineItemSerials"/>
              <span v-if="getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')==='true'" class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
                <span>
                  <h3>{{lookupBranch(warehouseLineItemSerialsDialog.location)}}</h3>
                  <span v-if="warehouseLineItemSerialsDialog.filtered.filter(x => x.locationId===warehouseLineItemSerialsDialog.location).length>0">
                    <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.filtered.filter(x => x.locationId===warehouseLineItemSerialsDialog.location)" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}} (ID: {{serial.id}})</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="serialDialog.data.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, warehouseLineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </span>
                  <span v-else>
                    <span>No matching serials entered for this location.</span>
                  </span>
                  <hr class="mb-2">
                </span>
              </span>
              <span v-else class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
              <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.filtered" :key="i">
                <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                  <b>{{serial.serial}}</b>
                  <span class="d-flex flex-row">
                    <v-btn v-if="serialDialog.data.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, warehouseLineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                    <!-- <v-btn v-if="serialDialog.data.status && serialDialog.data.status>=1" class="ml-2" @click="$router.push({path: '/products/serial/'+serial.serial})" color="success" fab x-small><v-icon>mdi-history</v-icon></v-btn> -->
                  </span>
                  <!-- <v-btn v-if="!serialDialog.data.status || serialDialog.data.status<1" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, warehouseLineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn> -->
                </span>
              </v-card>
            </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeWarehouseLineItemSerialsDialog">Close</v-btn>
        </v-card-actions>*
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<style>
#existingSerials{
  border-collapse: collapse;
}
#existingSerials td, #existingSerials th{
  border: 1px solid #ff8080;
  padding: 5px;
}
#existingSerials tbody tr:hover{
  background: #f50000;
  color: white;
}
</style>
<script>
  import axios from 'axios';
  import utils from "../../plugins/helpers";
  import {mapGetters} from 'vuex'
  import confirmedActionButton from './../../components/confirmedActionButton.vue';
  import dynamicButtonContainer from './../../components/dynamicButtonContainer.vue';
  export default {
    components: {
      confirmedActionButton,
      dynamicButtonContainer
    },
    data () {
      return {
        utils: utils,
        loader: false,
        noteLoading: false,
        snackObj: {
          state: false,
          color: '',
          text: ''
        },
        createDispatchLoading: false,
        serialDialog: {
          activeArea: null,
          isOpen: false,
          isLoading: false,
          isSyncing: false,
          isConfirming: false,

          selected: null,
          data: null,
          pljs: [],
          existing: null,
          headers: [
            {
              text: 'QTY',
              align: 'start',
              sortable: false,
              value: 'quantity',
            },
            {
              text: 'Product #',
              align: 'start',
              sortable: false,
              value: 'productId',
            },
            { text: 'Name', value: 'productName', sortable: false },
            { text: 'Serials', value: 'serials', sortable: false }
          ]
        },

        warehouses: [],

        allOrderDispatches: [],
        order: null,

        singular: "Dispatch",
        singularLower: "dispatch",
        plural: "Dispatches",
        pluralLower: "dispatches",

        statuses: [
          {text: "All", value: null},
          {text: "New", value: 0},
          {text: "In Progress", value: 1},
          {text: "Completed", value: 2},
          {text: "Voided", value: -1},
        ],

        //some includes itself because it's needed to show up in the v-select
        dispatchStatuses: [
          {text: "Voided", value: -1, allowedNext: [-1]},
          {text: "New", value: 0, allowedNext: [-1, 0, 1]},
          {text: "Scheduled", value: 1, allowedNext: [-1, 0, 1, 2, 3, 5]},
          {text: "Out for Delivery", value: 2, allowedNext: [-1, 1, 2, 3, 5]},
          {text: "Attempted Delivery", value: 3, allowedNext: [-1, 1, 2, 3, 5]},
          {text: "Delayed", value: 4, allowedNext: [-1, 1, 2, 3, 4, 5]},
          {text: "Delivered", value: 5, allowedNext: [5]},
          {text: "Other", value: -2, allowedNext: [-2, -1, 0, 1, 2, 3, 5]},
        ],
        tempStatus: 0,

        oneClickDispatchLoader: false,

        lineErrors: {
          productId: null,
          errors: []
        },

        lineItemSerialsDialog: {
          isOpen: false,
          data: null,
          isLoading: false
        },

        removeOrderLineItemSerialDialog: {
          isOpen: false,
          data: null,
          isLoading: false
        },

        warehouseLineItemSerialsDialog: {
          isOpen: false,
          data: null,
          location: null,
          isLoading: false
        },

        confirmCompositeQuantityType: {
          isOpen: false,
          data: null,
          confirm: false,
        },

        fillLoading: false,
        today: null,
      }
    },
    created(){
      let i = this.serialDialog.headers.findIndex(x => x.value==='serials');

      if(this.getGlobalValue('replaceProductSerialsWithIMEI')){
        if(i>=0){
          this.serialDialog.headers[i].text = this.serialNaming.plural
        }
      }
      if(!this.getGlobalValue('productSerialShowOnDispatch')){
        i = this.serialDialog.headers.findIndex(x => x.value==='serials');
        if(i>=0){
          this.serialDialog.headers.splice(i, 1);
        }
      }

      if(this.getGlobalValue('hiddenDispatchStatusesFromFrontend')){
        let statuses = this.getGlobalValue('hiddenDispatchStatusesFromFrontend').split(",").map(x => x.trim())

        for(let status of statuses){
          let sI = this.dispatchStatuses.findIndex(x => x.text===status);
          if(!sI<0) continue;

          let s = this.dispatchStatuses[sI];

          for(let ds of this.dispatchStatuses){
            if(ds.text===s.text) continue;
            ds.allowedNext = ds.allowedNext.filter(x => x!==s.value);
          }

          this.dispatchStatuses.splice(sI, 1);
        }
      }
    },
    async mounted(){
      try{
        let res = await axios.get(`${this.getEndpoint}/api/dispatch/allOrderDispatches/${this.$route.params.oid}`);
        if(res.data.error) throw res.data.error
        this.allOrderDispatches = res.data.data;
        this.order = res.data.order;

        if(!this.order) throw "Order data cannot be found."
        if(this.order?.deliveryInfo.deliveryType!=='delivery') throw "This is not a delivery order."

        await this.openSerialDialog(this.$route?.query.curr||null);

        if(this.serialDialog?.data?.DispatchLineItems){
          for(let item of this.serialDialog?.data?.DispatchLineItems){
            await this.getLineSerials(item.productId)
          }
        }

        if(this.getGlobalValue("VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING")==='true'){
          let warehouses = await axios.get(`${this.getEndpoint}/api/locations/warehouses`);
          if(warehouses.data.error) throw warehouses.data.error

          this.warehouses = warehouses.data.data;
          this.warehouses = this.warehouses.filter(x => x.id!==this.getBranch)
          this.warehouses = [{id: this.getBranch}].concat(this.warehouses);
        }

        let today = new Date();
        const offset = today.getTimezoneOffset()
        today = new Date(today.getTime() - (offset*60*1000))
        today = today.toISOString().split('T')[0];
        this.today = today;

        this.scrollTimelineToBottom();
      } catch (error) {
        console.error(error)
        this.snack(error.msg || error.msg?.message || error, "error");
      } finally {
        this.loader = false;
      }
    },
    computed: {
      changeDispatchStatusRules(){
        if(!this.serialDialog.data.orderId) return true
        else if(!this.serialDialog.data || this.serialDialog.data == {} || Object.keys(this.serialDialog.data).length == 0) return true
        else if(this.serialDialog.data.status == -1) return true
        else if(this.serialDialog.data.status == 5) return true
        else return false
      },
      voidDispatchRules(){
        if(!this.serialDialog.data.orderId) return true
        else if(!this.serialDialog.data || this.serialDialog.data == {} || Object.keys(this.serialDialog.data).length == 0) return true
        else if(this.serialDialog.data.status == -1) return true
        else if(this.serialDialog.data.status == 5) return true
        else return false
      },
      canPrint(){
        if(!this.serialDialog.data) return false;
        if(this.serialDialog.isLoading) return false;
        if(this.serialDialog.isSyncing) return false;
        // for(let oli of this.serialDialog.data.OrderLineItems){
        //   if(!oli.Product.metadata?.requireSerials) continue;
        //   if(!oli.Product.ProductSerials) return false;
        //   if(oli.Product.ProductSerials.length===0) return false;
        //   if(oli.Product.ProductSerials.length!==oli.quantity) return false;
        // }

        for(let oli of this.serialDialog.data.OrderLineItems){
          if(oli.Product?.metadata?.requireSerials){
            if(utils.pff(oli.quantity)!=(oli.serials?.length||0)) return false;
          }
          if(utils.pff(oli.quantity)<(oli.serials?.length||0)) return false
        }

        return true
      },
      ...mapGetters(['getId', 'getEndpoint', 'lookupUsername', 'getGlobalValue', 'lookupBranch', 'getBranch', 'getBranches', 'isAllowed', 'getUser', 'serialNaming']),
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      computeProductName(id){
        let name = this.serialDialog.data.Order.OrderLineItems.find(x=>x.productId === id)
        return name.productName
      },
      computeLineItem(item){
        let oli = this.serialDialog.data.Order.OrderLineItems.find(x => x.productId===item.productId);

        return oli;
      },
      computeProductSerial(serialId){
        let ps = this.serialDialog.data.Order.ProductSerials.find(x => x.id===serialId);

        return ps;
      },
      importAddressFromOrder(){
        this.serialDialog.data.address = {...this.serialDialog.data.Order.deliveryInfo.address}
        if(this.serialDialog.data.Order.Customer){
          this.serialDialog.data.address.phone = this.serialDialog.data.Order.Customer.phone
        }
        this.$forceUpdate()
      },
      updateLineTotals(){
        let qtyPrecision = this.getGlobalValue('quantityPrecision')||0

        for(let item of this.serialDialog.data.DispatchLineItems){
          item.scheduledQuantity = 0
          item.outForDeliveryQuantity = 0
          item.deliveredQuantity = 0

          if(item.metadata.compositeProductData){
            item.scheduledQuantity = null
            item.outForDeliveryQuantity = null
            item.deliveredQuantity = null

            for(let rawMat of item.metadata.compositeProductData){
              rawMat.scheduledQuantity = 0
              rawMat.outForDeliveryQuantity = 0
              rawMat.deliveredQuantity = 0
            }
          }

          for(let dispatch of this.allOrderDispatches){
            if(dispatch.status===-1) continue;

            let pli = dispatch.DispatchLineItems.find(x => x.productId===item.productId);
            if(!pli) continue;

            if(pli.metadata.compositeProductData){
              let schQty = null;
              let outQty = null;
              let delQty = null;

              for(let pliMat of pli.metadata.compositeProductData){
                let rawMat = item.metadata.compositeProductData?.find(x => x.productId===pliMat.productId);
                if(!rawMat) throw "Could not get rawMat from pliMat";

                if(dispatch.status===1) rawMat.scheduledQuantity+=utils.pff(pliMat.quantity);
                if(dispatch.status===2) rawMat.outForDeliveryQuantity+=utils.pff(pliMat.quantity);
                if(dispatch.status===5) rawMat.deliveredQuantity+=utils.pff(pliMat.quantity);

                let schQtyNew=utils.decimalAdjust("floor", utils.pff(rawMat.scheduledQuantity)/utils.pff(rawMat.metadata.baseQuantity), parseInt(qtyPrecision));
                let outQtyNew=utils.decimalAdjust("floor", utils.pff(rawMat.outForDeliveryQuantity)/utils.pff(rawMat.metadata.baseQuantity), parseInt(qtyPrecision));
                let delQtyNew=utils.decimalAdjust("floor", utils.pff(rawMat.deliveredQuantity)/utils.pff(rawMat.metadata.baseQuantity), parseInt(qtyPrecision));

                if(schQty===null || schQtyNew<schQty) schQty = schQtyNew;
                if(outQty===null || outQtyNew<outQty) outQty = outQtyNew;
                if(delQty===null || delQtyNew<delQty) delQty = delQtyNew;

                console.log(`Prod ${rawMat.productId}`, schQty, outQty, delQty)
              }

              item.scheduledQuantity=schQty;
              item.outForDeliveryQuantity=outQty;
              item.deliveredQuantity=delQty;
            }
            else{
              if(dispatch.status===1) item.scheduledQuantity+=utils.pff(pli.quantity);
              if(dispatch.status===2) item.outForDeliveryQuantity+=utils.pff(pli.quantity);
              if(dispatch.status===5) item.deliveredQuantity+=utils.pff(pli.quantity);
            }
          }

          item.balance = utils.pff(this.computeLineItem(item)?.quantity || 0)-item.scheduledQuantity-item.outForDeliveryQuantity-item.deliveredQuantity;

          if(item.metadata.compositeProductData){
            for(let rawMat of item.metadata.compositeProductData){
              rawMat.balance = utils.pff(rawMat.totalQuantity)-rawMat.scheduledQuantity-rawMat.outForDeliveryQuantity-rawMat.deliveredQuantity;
            }
          }
        }

        this.$forceUpdate();
      },
      async saveDispatch(id){
        try {
          this.loader = true;

          let obj = {...this.serialDialog.data}
          obj.status = this.tempStatus;

          let res = await axios.post(`${this.getEndpoint}/api/dispatch/save/${id}`, {data: obj})
          if(res.data.error) throw res.data.error

          let ix = this.allOrderDispatches.findIndex(x => x.dbID===res.data.data.dbID);
          if(ix>=0){
            this.allOrderDispatches[ix] = res.data.data
          }

          await this.openSerialDialog(this.serialDialog.data.id)

          this.$forceUpdate();

          this.snack("Dispatch data saved.")
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async oneClickDispatch(){
        try {
          this.oneClickDispatchLoader = true

          if(this.allOrderDispatches && this.allOrderDispatches.length!==0) throw "One-click Dispatch can only be done when there are no dispatches on the order."

          await this.createNewDispatch(this.order.id);

          await this.fillQTYBalance(null, null);

          this.serialDialog.data.scheduledOutAt = (new Date()).toLocaleDateString('en-CA');

          this.serialDialog.data.driver = this.getGlobalValue('oneClickDispatchDriverPrefill')||'';

          this.tempStatus = 5;

          await this.saveDispatch(this.serialDialog.data.dbID);


        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.oneClickDispatchLoader = false
        }
      },
      async createNewDispatch(id){
        try {
          this.createDispatchLoading = true

          let res = await axios.post(`${this.getEndpoint}/api/dispatch/${id}`)
          if(res.data.error) throw res.data.error

          if(!this.allOrderDispatches){
            this.allOrderDispatches = []
          }

          this.allOrderDispatches.push(res.data.data)
          await this.selectActiveDispatch(this.allOrderDispatches.length-1)

          this.snack("New Dispatch Created.")
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.createDispatchLoading = false
        }
      },
      async clickDispatch(dispatchId){
        await this.openSerialDialog(dispatchId)
        if(this.$route.query.curr!==dispatchId){
          await this.$router.replace({path: `/dispatch/view/${this.$route.params.oid}`, query: {curr: dispatchId}});
        }
      },
      async selectActiveDispatch(index){
        await this.getOrderData(this.allOrderDispatches[index].id)

        this.tempStatus = this.serialDialog.data.status;

        if(!this.serialDialog.data.address){
          this.serialDialog.data.address = {}
        }

        this.scrollTimelineToBottom();

        this.updateLineTotals();
      },
      async openSerialDialog(dispatchId=null){
        try{
          this.serialDialog.isSyncing = true;

          this.serialDialog.isOpen = true;
          if(this.allOrderDispatches && this.allOrderDispatches.length > 0){
            let dix = this.allOrderDispatches.findIndex(x => x.id===dispatchId);
            await this.selectActiveDispatch(dix>=0?dix:0)
          }
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.serialDialog.isSyncing = false;
        }
      },
      closeSerialDialog(keepExisting=false){
        this.serialDialog.isOpen = false;
        this.serialDialog.selected = null;
        this.serialDialog.data = null;
        this.serialDialog.data = {}
        if(!keepExisting) this.serialDialog.existing = null;
      },
      async getOrderData(id){
        let res = await axios.get(`${this.getEndpoint}/api/dispatch/${this.$route.params.oid}/${id}`)
        if(res.data.error) throw res.data.error

        this.serialDialog.data = res.data.data
        this.serialDialog.pljs = res.data.pljs || [];
      },
      async openLineItemSerialsDialog(item){
        try{
          this.lineItemSerialsDialog.isLoading = true;
          this.lineItemSerialsDialog.data = item;

          await this.getLineSerials();

          this.lineItemSerialsDialog.filtered = item.serials?[...item.serials]:[]

          this.lineItemSerialsDialog.isOpen = true;
          this.lineItemSerialsDialog.other = null;
          this.lineItemSerialsDialog.search = "";
          this.lineItemSerialsDialog.newSerial = ""
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.lineItemSerialsDialog.isLoading = false;
        }
      },
      closeLineItemSerialsDialog(){
        this.lineItemSerialsDialog.isOpen = false;
        this.lineItemSerialsDialog.data = null;
        this.lineItemSerialsDialog.other = null;
        this.lineItemSerialsDialog.search = "";
        this.lineItemSerialsDialog.newSerial = ""
        this.lineItemSerialsDialog.filtered = []
      },
      async getLineSerials(productId=null){
        if(!this.lineItemSerialsDialog.data && !productId) return;

        let res = await axios.post(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.dbID}/getDispatchLineSerials`, {productId: this.lineItemSerialsDialog?.data?.productId || productId})
        if(res.data.error) throw res.data.error

        if(!productId){
          this.lineItemSerialsDialog.data.serials = res.data.data
        }
        else{
          let lii = this.serialDialog.data.DispatchLineItems.findIndex(x => x.productId===productId);
          if(lii>=0){
            this.serialDialog.data.DispatchLineItems[lii].serials = res.data.data;
          }
        }

        this.filterLineItemSerials();

        this.updateLineTotals();
      },
      async openWarehouseLineItemSerialsDialog(item, loc){
        try{
          this.warehouseLineItemSerialsDialog.isLoading = true;
          this.warehouseLineItemSerialsDialog.data = item;
          this.warehouseLineItemSerialsDialog.location = loc.locationId;

          await this.getWarehouseLineSerials();

          this.warehouseLineItemSerialsDialog.filtered = item.serials?[...item.serials]:[]

          this.warehouseLineItemSerialsDialog.isOpen = true;
          this.warehouseLineItemSerialsDialog.other = null;
          this.warehouseLineItemSerialsDialog.search = "";
          this.warehouseLineItemSerialsDialog.newSerial = ""
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.warehouseLineItemSerialsDialog.isLoading = false;
        }
      },
      closeWarehouseLineItemSerialsDialog(){
        this.warehouseLineItemSerialsDialog.isOpen = false;
        this.warehouseLineItemSerialsDialog.data = null;
        this.warehouseLineItemSerialsDialog.location = null;
        this.warehouseLineItemSerialsDialog.other = null;
        this.warehouseLineItemSerialsDialog.search = "";
        this.warehouseLineItemSerialsDialog.newSerial = ""
        this.warehouseLineItemSerialsDialog.filtered = []
      },
      async getWarehouseLineSerials(){
        if(!this.warehouseLineItemSerialsDialog.data) return;

        let res = await axios.post(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.dbID}/getDispatchLineSerials`, {productId: this.warehouseLineItemSerialsDialog.data.productId})
        if(res.data.error) throw res.data.error

        this.warehouseLineItemSerialsDialog.data.serials = res.data.data

        this.filterWarehouseLineItemSerials();

        this.updateLineTotals();
      },
      async addWarehouseLineItemSerial(){
        try{
          this.warehouseLineItemSerialsDialog.isLoading = true;

          let item = this.warehouseLineItemSerialsDialog.data

          if(!this.warehouseLineItemSerialsDialog.newSerial?.trim()){
            throw `Serial cannot be empty.`
          }

          this.warehouseLineItemSerialsDialog.newSerial.replace("\\//\\=", "")

          if(item.serials?.length>=utils.pff(item.quantity)){
            throw `Max number of ${this.serialNaming.pluralLower} for this line item.`
          }

          let res = await axios.post(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.dbID}/dispatchWarehouseSerials`, {productId: item.productId, serial: this.warehouseLineItemSerialsDialog.newSerial.trim(), location: this.warehouseLineItemSerialsDialog.location})
          if(res.data.error) throw res.data.error

          let lix = this.serialDialog.data.DispatchLineItems.findIndex(x=>x.productId === item.productId)
          this.warehouseLineItemSerialsDialog.data = res.data.data.item

          this.serialDialog.data.DispatchLineItems.splice(lix,1,res.data.data.item)
          this.serialDialog.data.history = res.data.data.history

          this.scrollTimelineToBottom();

          await this.getWarehouseLineSerials();

          this.$forceUpdate()

          this.warehouseLineItemSerialsDialog.newSerial = ""
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.warehouseLineItemSerialsDialog.isLoading = false;
        }
      },
      scrollTimelineToBottom(){
        let timelineDiv = document.getElementById("timeline");
        if(!timelineDiv) return;

        timelineDiv.scrollTop = timelineDiv.scrollHeight;
      },
      async addLineItemSerial(){
        try{
          this.lineItemSerialsDialog.isLoading = true;

          let item = this.lineItemSerialsDialog.data

          if(!this.lineItemSerialsDialog.newSerial?.trim()){
            throw `Serial cannot be empty.`
          }

          this.lineItemSerialsDialog.newSerial.replace("\\//\\=", "")

          if(item.serials?.length>=utils.pff(item.quantity)){
            throw `Max number of ${this.serialNaming.pluralLower} for this line item.`
          }

          let res = await axios.post(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.orderId}/dispatchSerials`, {dispatchId: this.serialDialog.data.id, productId: item.productId, serial: this.lineItemSerialsDialog.newSerial.trim()})
          if(res.data.error) throw res.data.error

          let lix = this.serialDialog.data.DispatchLineItems.findIndex(x=>x.productId === item.productId)
          this.lineItemSerialsDialog.data = res.data.data.item

          this.serialDialog.data.DispatchLineItems.splice(lix,1,res.data.data.item)
          this.serialDialog.data.history = res.data.data.history

          this.scrollTimelineToBottom();

          await this.getLineSerials();

          this.$forceUpdate()

          this.lineItemSerialsDialog.newSerial = ""
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.lineItemSerialsDialog.isLoading = false;
        }
      },
      async removeLineItemSerial(serial, dialog){
        try{
          this.lineItemSerialsDialog.isLoading = true;

          let item = dialog.data;

          let res = await axios.put(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.dbID}/dispatchSerials`, {productId: item.productId, serialId: serial})
          if(res.data.error) throw res.data.error

          let lix = this.serialDialog.data.DispatchLineItems.findIndex(x=>x.productId === item.productId)
          dialog.data = res.data.data.item
          this.serialDialog.data.DispatchLineItems.splice(lix,1,res.data.data.item)

          this.serialDialog.data.history = res.data.data.history

          this.scrollTimelineToBottom();

          await this.getLineSerials();
          await this.getWarehouseLineSerials();

          this.$forceUpdate()
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.lineItemSerialsDialog.isLoading = false;
        }
      },
      openRemoveOrderLineItemSerialDialog(item){
        this.removeOrderLineItemSerialDialog.data = item;
        this.removeOrderLineItemSerialDialog.isOpen = true;
      },
      closeRemoveOrderLineItemSerialDialog(){
        this.removeOrderLineItemSerialDialog.isOpen = false;
        this.removeOrderLineItemSerialDialog.data = null;
      },
      async removeOrderLineItemSerial(){
        try{
          this.removeOrderLineItemSerialDialog.isLoading = true;

          let id = this.removeOrderLineItemSerialDialog.data.orderId;

          let res = await axios.put(`${this.getEndpoint}/api/${this.singularLower}/${this.serialDialog.data.orderId}/removeSerialFromOrder`, {serialId: id})
          if(res.data.error) throw res.data.error

          let lix = this.serialDialog.data.Order.ProductSerials.findIndex(x=>x.id === id)
          this.serialDialog.data.Order.ProductSerials.splice(lix,1)

          this.closeRemoveOrderLineItemSerialDialog();

          this.$forceUpdate()
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        }
        finally {
          this.removeOrderLineItemSerialDialog.isLoading = false;
        }
      },
      filterLineItemSerials(){
        if(!this.lineItemSerialsDialog.data) return;

        if(!this.lineItemSerialsDialog.search){
          this.lineItemSerialsDialog.filtered = [...this.lineItemSerialsDialog.data.serials]
          return
        }

        this.lineItemSerialsDialog.filtered = this.lineItemSerialsDialog.data.serials.filter(x => x.toLowerCase().includes(this.lineItemSerialsDialog.search.toLowerCase()))
      },
      filterWarehouseLineItemSerials(){
        if(!this.warehouseLineItemSerialsDialog.data) return;

        if(!this.warehouseLineItemSerialsDialog.search){
          this.warehouseLineItemSerialsDialog.filtered = [...this.warehouseLineItemSerialsDialog.data.serials]
          return
        }

        this.warehouseLineItemSerialsDialog.filtered = this.warehouseLineItemSerialsDialog.data.serials.filter(x => x.toLowerCase().includes(this.warehouseLineItemSerialsDialog.search.toLowerCase()))
      },
      async updateLineItem(item, reset=false){
        try {
          this.serialDialog.isSyncing = true;

          let tempItem = {...item};

          if(tempItem.metadata.quantities?.length>0){
            for(let loc of tempItem.metadata.quantities){
              if(!loc.deliveryQuantity) loc.deliveryQuantity = 0;
              else loc.deliveryQuantity = utils.pff(loc.deliveryQuantity);
            }
            tempItem.quantity = utils.pff(tempItem.metadata.quantities.reduce((a, c) => a+utils.pff(c.deliveryQuantity), 0));
          }

          else if(!tempItem.quantity) tempItem.quantity = utils.pff(0)

          tempItem.quantity = utils.pff(tempItem.quantity)

          let ucq = false;
          if(item.metadata.compositeProductData){
            ucq = item.metadata.useCompositeQuantities;
          }

          let res = await axios.put(`${this.getEndpoint}/api/dispatch/updateLineItem/${this.serialDialog.data.dbID}`, {item: tempItem, useCompositeQuantities: ucq, reset: reset})
          if(res.data.error) throw res.data.error

          let prodId = item.compositeParent?item.compositeParent:item.productId;
          let ix = this.serialDialog.data.DispatchLineItems.findIndex(x=>x.productId===prodId)
          if(ix>=0) {
            this.serialDialog.data.DispatchLineItems[ix] = res.data.data;
            //item.quantity = res.data.data.quantity;
            this.$forceUpdate();
          }

          console.log(this.serialDialog.data.DispatchLineItems[ix])

          this.updateLineTotals();

          this.$forceUpdate()
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.serialDialog.isSyncing = false;
        }
      },
      async fillQTYBalance(rawItem=null, rawLoc=null){
        try{
          this.fillLoading = true;

          if(rawItem){
            let orderItem = this.computeLineItem(rawItem);

            let multiBalance = 0;
            if(rawItem.metadata?.quantities?.length>0){
              for(let loc of rawItem.metadata.quantities){
                if(loc.locationId!==rawLoc.locationId){
                  loc.deliveryQuantity = 0
                }
                else{
                  loc.deliveryQuantity = rawItem.balance || 0
                }

                multiBalance+=loc.deliveryQuantity
              }
            }
            rawItem.quantity = rawItem.metadata?.quantities?.length>0?multiBalance:(rawItem.balance || orderItem?.quantity || 0)

            await this.updateLineItem(rawItem)
          }
          else{
            for(let item of this.serialDialog.data.DispatchLineItems){
              let orderItem = this.computeLineItem(item);

              let multiBalance = 0;
              if(item.metadata?.quantities?.length>0){
                for(let loc of item.metadata.quantities){
                  loc.deliveryQuantity = loc.quantity
                  multiBalance+=loc.quantity;
                }
              }
              item.quantity = item.metadata?.quantities?.length>0?multiBalance:(item.balance || orderItem?.quantity || 0)

              await this.updateLineItem(item)
            }
          }
        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.fillLoading = false;
        }
      },
      async updateCompositeQuantityType(){
        let item = this.confirmCompositeQuantityType.data;

        let mode = !!item.metadata.useCompositeQuantities;
        item.metadata.useCompositeQuantities = !mode;

        this.$forceUpdate()

        this.closeConfirmCompositeQuantityTypeDialog();

        await this.updateLineItem(item, true);
      },
      openConfirmCompositeQuantityTypeDialog(item){
        this.confirmCompositeQuantityType.data = item;
        this.confirmCompositeQuantityType.isOpen = true;
      },
      closeConfirmCompositeQuantityTypeDialog(){
        this.confirmCompositeQuantityType.isOpen = false;
        this.confirmCompositeQuantityType.data = null;
      },
      getPLJQTY(pId, lId){
        if(!this.serialDialog?.pljs) return 'N/A';
        let plj = this.serialDialog.pljs.find(x => x.productId===pId && x.locationId===lId)
        if(plj!==null) return plj.quantity
        return 'N/A';
      }
    }
  }
</script>
